import React from 'react';
import useNotifications from '@/hooks/useNotifications';
import { NotifTypes } from '@/type';
import AgbChangedModal from '@/screens/main/components/dialogs/agb-changed';
import PremiumExpiredModal from '@/screens/main/components/dialogs/premium-expired';
import SubscribeNewslettersModal from '@/screens/main/components/dialogs/subscribe-newsletters';
import NotificationsContext from './notifications-context-type';

const NotificationsProvider: React.FC = ({ children }) => {
  const { notifications } = useNotifications();

  const agbNotification = notifications.find((notif) => notif.parsedData.type === NotifTypes.AGB);
  const premiumNotification = notifications.find(
    (notif) => notif.parsedData.type === NotifTypes.PREMIUM
  );
  const subscribeNotification = notifications.find(
    (notif) => notif.parsedData.type === NotifTypes.SUBSCRIBE_NEWSLETTERS
  );

  return (
    <NotificationsContext.Provider value={{}}>
      {children}
      {agbNotification && <AgbChangedModal agbChangedNotificationId={agbNotification.id} />}
      {premiumNotification && (
        <PremiumExpiredModal premiumExpiredNotificationId={premiumNotification.id} />
      )}
      {subscribeNotification && (
        <SubscribeNewslettersModal notificationId={subscribeNotification.id} />
      )}
    </NotificationsContext.Provider>
  );
};

export default NotificationsProvider;
